module.exports = __webpack_public_path__ + "media/3762940816.46fa33f7.mp3";